// John Eldhose 20200625
import axios from 'axios';

const getData = async (url) => {
  const get = await axios.get('/api/index.php/' + url)
    .then((res) => {
      return res['data'];
    })
    .catch((err) => {
      console.log(err);
      return false;
    })
  return get;
}
const postData = async (url, data) => {
  var qs = require('qs');
  const post = await axios.post('/api/index.php/' + url, qs.stringify(data))
    .then((res) => {
      return res['data'];
    })
    .catch((err) => {
      console.log(err);
      return false;
    })
  return post;
}

export { getData, postData };



// WEBPACK FOOTER //
// ./src/components/lib/api.js